import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

const RoleGuard = ({ allow = null, deny = null, redirectTo = '/tasks' }) => {
    const { role, user, isLoading } = useSelector((state) => state.auth);
    if (isLoading) return null;
    if (!user) return <Navigate to="/login" replace />;

    if (Array.isArray(deny) && deny.includes(role)) {
        return <Navigate to={redirectTo} replace />;
    }
    if (Array.isArray(allow) && !allow.includes(role)) {
        return <Navigate to={redirectTo} replace />;
    }

    return <Outlet />;
};

export default RoleGuard;


